/* eslint-disable consistent-return */
function authHeader() {
  const token = localStorage.getItem('serviceToken');
  if (token) {
    return `Bearer ${token}`;
  }
}

export default authHeader;
